"use client";

import {
  forceStartRecording as statsigForceStartRecording,
  stopRecording as statsigStopRecording,
} from "@statsig/session-replay";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";

import { sessionReplayPlugin } from "@/apps/charm/lib/statsig-session-replay";
import { publicEnv } from "@/lib/env/public";

const sampledSessionReplayPlugin = sessionReplayPlugin();
const forcedSessionReplayPlugin = sessionReplayPlugin({
  forceRecording: true,
});
const autoCapturePlugin = new StatsigAutoCapturePlugin({
  consoleLogAutoCaptureSettings: {
    enabled: true,
    logLevel: "warn",
  },
});

interface StatsigPluginOptions {
  forceSessionReplay?: boolean;
}

function getStatsigClientKey(): string | null {
  const sdkKey = publicEnv("STATSIG_CLIENT_KEY")?.trim();
  return sdkKey != null && sdkKey.length > 0 ? sdkKey : null;
}

function getStatsigPlugins(options: StatsigPluginOptions = {}) {
  return [
    options.forceSessionReplay
      ? forcedSessionReplayPlugin
      : sampledSessionReplayPlugin,
    autoCapturePlugin,
  ];
}

export function forceStartRecording(): boolean {
  const sdkKey = getStatsigClientKey();
  if (sdkKey == null) {
    return false;
  }
  statsigForceStartRecording(sdkKey);
  return true;
}

export function stopRecording(): boolean {
  const sdkKey = getStatsigClientKey();
  if (sdkKey == null) {
    return false;
  }
  statsigStopRecording(sdkKey);
  return true;
}

export const statsigPlugins = getStatsigPlugins();
export const forcedStatsigPlugins = getStatsigPlugins({
  forceSessionReplay: true,
});
